// extracted by mini-css-extract-plugin
export var dataCell = "_p2-2";
export var dataRow = "_p2-0";
export var headerRow = "_p2-1";